import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { OrderService } from 'src/app/services/order/order.service';

@Component({
  selector: 'app-hrdashboard',
  templateUrl: './hrdashboard.component.html',
  styleUrls: ['./hrdashboard.component.css']
})
export class HrdashboardComponent implements OnInit {

  
  data: any;
  filledOrder: any;
  pendingOrder: any;
  cancelledOrder : any;


  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService, private orderServices: OrderService) { }

  ngOnInit() {
    this.getAllOrderList();
    this.getAllFilledOrder();
    this.getAllPendingOrder();
    this.getAllCancelledOrder();
  }

  getAllOrderList() {
    this.orderServices.getAllOrderList().subscribe(
      (data: any) => {
        this.data = data;
        console.log(this.data);
      }
    )
  }

  getAllFilledOrder() {
    this.orderServices.getAllFilledOrder().subscribe(
      (data: any) => {
        this.filledOrder = data;
        console.log(this.data);
      }
    )
  }

  getAllPendingOrder() {
    this.orderServices.getAllPendingOrder().subscribe(
      (data: any) => {
        this.pendingOrder = data;
        console.log(this.data);
      }
    )
  }

  getAllCancelledOrder() {
    this.orderServices.getAllCancelledOrder().subscribe(
      (data: any) => {
        this.cancelledOrder = data;
        console.log(this.data);
      }
    )
  }

  ViewOrder(orderno: string) {
    if (orderno != null) {
      this.router.navigate(['/manageorder', orderno]);
    }
  }



}
